import { useCallback, useMemo } from 'react';
import { openNewWindow } from '../../api/utils/util-func';
import { LmsLinkItemKey } from '../../constants/types/lms/type';
import { selectLmsLink } from '../../store/features/lmsLinkSlice';
import { openAlert } from '../../store/features/modalSlice';
import { useAppDispatch, useAppSelector } from '../../store/hook';

/**
 * LMS '이용 안내' 링크를 조회하고 여는 공통 훅.
 *
 * 여러 페이지에서 반복되던 아래 로직을 한 곳으로 모은다.
 * - lmsLink 스토어에서 itemKey 로 링크 조회
 * - 링크가 없으면 안내 얼럿 노출
 * - 링크가 있으면 새 창으로 열기
 */
export const useLmsGuideLink = (itemKey: LmsLinkItemKey) => {
  const lmsLink = useAppSelector(selectLmsLink);
  const dispatch = useAppDispatch();

  const link = useMemo(
    () => lmsLink?.links.find((item) => item.itemKey === itemKey)?.link ?? null,
    [lmsLink, itemKey],
  );

  const openGuide = useCallback(() => {
    if (!link) {
      dispatch(
        openAlert({ message: '링크가 없습니다. 관리자에게 문의해주세요.' }),
      );
      return;
    }

    openNewWindow(link);
  }, [link, dispatch]);

  return { link, openGuide };
};
